<div class="orders py-3 pagination-order">
  <header
    class="orders-header d-flex align-items-center justify-content-between has-border pb-2 mb-2">
    <h3 class="mb-0">Invoice Email</h3>
    <div class="lds-ring inline me-auto ms-2" *ngIf="showSmallLoader">
      <div></div>
      <div></div>
      <div></div>
    </div>
    <div class="ordersummary-panel ml-auto d-flex justify-content-between">
      <div
        class="form-check form-switch d-flex align-items-center m-0 justify-content-end gap-2">
        <div>
          <p-checkbox
            id="copyBcCheckbox"
            [ngModelOptions]="{ standalone: true }"
            [(ngModel)]="copyBcCheckbox"
            inputId="copyBcCheckbox"
            [binary]="true"
            (onChange)="copyBcBAcToGrid()"></p-checkbox>

          <label class="mx-2" for="copyBcCheckbox"> Copy BC </label>
        </div>
        <div>
          <p-checkbox
            id="copyBacCheckbox"
            [ngModelOptions]="{ standalone: true }"
            [(ngModel)]="copyBacCheckbox"
            inputId="copyBacCheckbox"
            [binary]="true"
            (onChange)="copyBcBAcToGrid()"></p-checkbox>
          <label class="mx-2" for="copyBacCheckbox"> BAC </label>
        </div>
      </div>
    </div>
    <div class="d-flex">
      <div class="ordersummary-panel ml-auto d-flex justify-content-between">
        <div class="nav-link p-0 d-flex align-items-center">
          <a class="link" (click)="onAdd()"><i class="pi pi-plus"></i> Add</a>
        </div>
      </div>
      <div class="ordersummary-panel ml-auto d-flex justify-content-between">
        <div class="ms-3 nav-link p-0 d-flex align-items-center">
          <a class="link delcol" (click)="onDelete()"
            ><i class="pi pi-trash"></i> Delete</a
          >
        </div>
      </div>
    </div>
  </header>
  <p-table
    #dt
    stripedRows
    [rowHover]="true"
    [rows]="25"
    [showCurrentPageReport]="true"
    [scrollable]="true"
    scrollHeight="calc(100vh - 310px)"
    [size]="'small'"
    [resizableColumns]="true"
    [value]="invoiceEmailListing"
    [(selection)]="invoiceEmailSelected"
    styleClass="p-datatable-customers ordersLineItems no-wrap table-hover-bg"
    [rowHover]="true"
    [rows]="10"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 25, 50]"
    [paginator]="false"
    [filterDelay]="0"
    dataKey="id"
    editMode="row"
    selectionMode="multiple"
    styleClass="table-listing">
    <ng-template pTemplate="header">
      <tr class="table-head">
        <th></th>
        <th style="text-align: center">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
        <th class="name">Name</th>
        <th class="purpose">Purpose</th>
        <th class="email">Email</th>
        <th class="save">Save</th>
        <th class="exist">Exist</th>
        <th class="confirmation">Conf</th>
        <th class="confirmation">Inv</th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-invoicedEmail
      let-editing="editing"
      let-ri="rowIndex">
      <ng-container>
        <tr class="p-selectable-row" [pEditableRow]="invoicedEmail">
          <td style="text-align: center">
            <button
              *ngIf="!editing"
              pButton
              pRipple
              type="button"
              pInitEditableRow
              icon="pi pi-pencil"
              class="p-button-rounded p-button-text"
              (click)="onEditRow(invoicedEmail)"></button>
            <button
              *ngIf="editing"
              pButton
              pRipple
              type="button"
              pSaveEditableRow
              icon="pi pi-check"
              class="p-button-rounded p-button-text p-button-success p-mr-2"
              (click)="onSaveRow(invoicedEmail)"></button>
            <button
              *ngIf="editing"
              pButton
              pRipple
              type="button"
              pCancelEditableRow
              icon="pi pi-times"
              class="p-button-rounded p-button-text p-button-danger"></button>
          </td>
          <td class="col-center">
            <p-tableCheckbox [value]="invoicedEmail"></p-tableCheckbox>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  jniAutoCompleteBlocker
                  pInputText
                  [ngModelOptions]="{ standalone: true }"
                  style="width: 6rem"
                  type="text"
                  [(ngModel)]="invoicedEmail.name"
                  required />
              </ng-template>
              <ng-template pTemplate="output">
                {{ invoicedEmail.name }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <!-- <p-cellEditor>
              <ng-template pTemplate="input">
                <input pInputText 
                  jniAutoCompleteBlocker
                  pInputText
                  [ngModelOptions]="{ standalone: true }"
                  style="width: 6rem"
                  type="text"
                  [(ngModel)]="invoicedEmail.purpose"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                {{ invoicedEmail.purpose }}
              </ng-template>
            </p-cellEditor> -->

            <p-cellEditor>
              <ng-template pTemplate="input">
                <p-select
                  [appendTo]="'body'"
                  [filter]="true"
                  [showClear]="true"
                  [options]="type"
                  optionLabel="name"
                  optionValue="name"
                  class="invoiceemailoptionstobody"
                  [(ngModel)]="invoicedEmail.purpose">
                </p-select>
              </ng-template>
              <ng-template pTemplate="output">
                {{ invoicedEmail.purpose }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  jniAutoCompleteBlocker
                  pInputText
                  [ngModelOptions]="{ standalone: true }"
                  style="width: 8rem"
                  type="text"
                  [(ngModel)]="invoicedEmail.email"
                  required />
              </ng-template>
              <ng-template pTemplate="output">
                {{ invoicedEmail.email }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-checkbox
              id="save"
              [ngModelOptions]="{ standalone: true }"
              [(ngModel)]="invoicedEmail.save"
              inputId="save"
              [binary]="true"></p-checkbox>
          </td>
          <td>
            <p-checkbox
              id="exist"
              [ngModelOptions]="{ standalone: true }"
              [(ngModel)]="invoicedEmail.exist"
              inputId="exist"
              [binary]="true"></p-checkbox>
          </td>

          <td>
            <p-checkbox
              id="confirmation"
              [ngModelOptions]="{ standalone: true }"
              [(ngModel)]="invoicedEmail.confirmation"
              inputId="confirmation"
              [binary]="true"></p-checkbox>
          </td>
          <td>
            <p-checkbox
              id="invoice"
              [ngModelOptions]="{ standalone: true }"
              [(ngModel)]="invoicedEmail.invoice"
              inputId="invoice"
              [binary]="true"
              [disabled]="true"></p-checkbox>
          </td>
        </tr>
      </ng-container>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="20">No line item found.</td>
      </tr>
    </ng-template>
  </p-table>
</div>
